<template>
  <div>
    <z-header :title="title" :actions="actions"></z-header>
    <Form :data="entry" :isEdit="true" @save="save" />
  </div>
</template>

<script>
import ZHeader from "../../layout/Header";
import fleet from "../../services/fleetUser";
import Form from "./Form.vue";
import fleetUser from "../../services/fleetUser";
import { formatDocument } from "../../filters/document";

export default {
  data() {
    return {
      title: "Editar motorista",
      id: null,
      entry: {},
      isLoading: false,
      actions: []
    };
  },
  mounted() {
    this.id = this.$route.params.id;

    this.actions.push({
      label: "Excluir",
      route: `/motoristas/${this.id}/remover`,
      class: "is-danger"
    });

    this.loadData();
  },
  methods: {
    loadData() {
      fleet.get(this.id).then(data => {
        this.entry = data;
        this.entry.restrictionGroupId = data && data.restrictionGroup
          ? data.restrictionGroup.id
          : null;
        this.entry.document = formatDocument(this.entry.document);
      });
    },
    async save(rawData) {
      try {
        await fleetUser.update(this.id, rawData);

        this.$router.push({
          name: "fleetUser"
        });
      } catch (err) {
        const {
          response: { data }
        } = err;

        const message = data.message && data.message.error ? data.message.error : "Erro ao atualizar o motorista";

        this.$buefy.toast.open({
          message,
          type: "is-danger"
        });
      }
    }
  },
  components: {
    ZHeader,
    Form
  }
};
</script>

<style lang="scss"></style>
